<div class="d-flex justify-content-center" *ngIf="hideMainContainer && hideGenerateDeviceUserBtn">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="d-flex justify-content-center" *ngIf="!hideGenerateDeviceUserBtn">
    <button type="button" class="btn btn-lg btn-primary" (click)="generateNewDeviceUsers()">Generate Device
        Users</button>
</div>
<div class="columns-row row" *ngIf="!hideMainContainer">
    <div class="col-7 column">
        <table class="table">
            <thead>
                <th>Name</th>
                <th>Rule</th>
                <th>Username</th>
                <th>Access Code</th>
                <th>Level 1 Code</th>
                <th>Level 2 Code</th>
                <th>Logged In</th>
                <th>Price List</th>
                <th>Device Name</th>
                <th>Actions</th>
            </thead>
            <tbody>
                <tr *ngFor="let deviceUser of deviceUsers">
                    <td>{{deviceUser.name}}</td>
                    <td>{{deviceUser.deviceUserType.name}}</td>
                    <td>{{deviceUser.username}}</td>
                    <td>{{deviceUser.pinCode}}</td>
                    <td>{{deviceUser.lvlOnePin}}</td>
                    <td>{{deviceUser.lvlTwoPin}}</td>
                    <td class="text-center">
                        <ng-container *ngIf="deviceUser.pinCodeUse === true; else loggedOutTemplate">
                            <i style="color: green;" class="fas fa-check"></i>
                        </ng-container>
                        <ng-template #loggedOutTemplate>
                            <i style="color: red;" class="fas fa-times"></i>
                        </ng-template>
                    </td>
                    <td>{{ (!deviceUser.priceList) ? 'Not Assigned' : deviceUser.priceList.name }}</td>
                    <td>{{ (!deviceUser.device) ? 'Not Assigned' : deviceUser.device.name }}</td>
                    <td class="text-right">
                        <button type="button" class="btn btn-secondary btn-sm"
                            data-toggle="tooltip" data-placement="top" title="Edit Device user"
                            (click)="showUpdateDeviceUserContent(deviceUser.id)"><i class="fa fa-edit"></i>
                        </button>
                        <ng-container *ngIf="deviceUser.pinCodeUse">
                            <button type="button" class="btn btn-danger btn-sm ml-1" data-toggle="tooltip"
                                data-placement="top" title="Logout Device user" (click)="logoutDeviceUser(deviceUser)">
                                <i class="fa fa-sign-out-alt"></i>
                            </button>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="!eventWithoutPrinters" style="display: flex; padding-left: 15px; gap: 10px; font-size: 16px;">
          <div style="font-size: 12px;font-weight: bold; margin-right: 10px">Font size of receipt:</div>
          <div style="font-size: 12px">Standart</div>
          <input style="margin-right: 10px" type="radio" name="printSize" id="printSizeSmall" [value]="0" (change)="updateEvent()" [(ngModel)]="event.deviceReceiptSize">
          <div style="font-size: 12px">Large</div>
          <input type="radio" name="printSize" id="printSizeLarge" [value]="1" (change)="updateEvent()" [(ngModel)]="event.deviceReceiptSize">
        </div>
    </div>
    <div class="col-5 column">
        <div class="card" *ngIf="showEditContent">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <app-form-group-input label="Device User Name" placeHolder="Device User Name"
                            [(model)]="deviceUser.name">
                        </app-form-group-input>
                    </div>
                    <div class="col">
                        <app-form-group-input label="Login Username" placeHolder="Login Username"
                            [(model)]="deviceUser.username">
                        </app-form-group-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-form-group-input label="Login Password" placeHolder="Login Password" [disabled]="true"
                            [(model)]="deviceUser.pinCode"></app-form-group-input>
                    </div>
                    <div class="col">
                        <app-form-group-input label="Lvl 1 Pin" placeHolder="Lvl 1 Pin"
                            [(model)]="deviceUser.lvlOnePin">
                        </app-form-group-input>
                    </div>
                    <div class="col">
                        <app-form-group-input label="Lvl 2 Pin" placeHolder="Lvl 2 Pin"
                            [(model)]="deviceUser.lvlTwoPin">
                        </app-form-group-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-select label="Price List" [(model)]="priceListId" [options]="assignedPriceListOptions"
                            (modelChange)="onPriceListChangeEvent()"></app-select>
                    </div>
                    <div class="col">
                        <app-form-group-input label="Device User Type" placeHolder="Device User Type"
                            [(model)]="deviceUser.deviceUserType.name" [disabled]="true"></app-form-group-input>
                    </div>
                    <div class="col">
                        <app-select label="Device" [options]="devicesListOptions" [(model)]="deviceId"
                            (modelChange)="onDeviceChangeEvent()"></app-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="paymentCheckbox"
                                [(ngModel)]="deviceUser.enablePaymentScreen">
                            <label class="form-check-label" for="paymentCheckbox">Payment Screen</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="sellsCheckbox"
                                [(ngModel)]="deviceUser.showSales">
                            <label class="form-check-label" for="sellsCheckbox">Sales turnover</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="doublePrintCheckbox"
                           [(ngModel)]="deviceUser.enableDoublePrint">
                      <label class="form-check-label" for="doublePrintCheckbox">Double printout</label>
                      </div>
                    </div>
                    <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="paidWithoutPrintCheckbox"
                           [(ngModel)]="deviceUser.paidWithoutPrint">
                      <label class="form-check-label" for="paidWithoutPrintCheckbox">Deactivate receipt printing</label>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col" *ngIf="event.hasSumUp && (deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2)">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="enableSumUpCheckbox"
                             [(ngModel)]="deviceUser.enableSumUp">
                      <label class="form-check-label" for="enableSumUpCheckbox">SumUp</label>
                    </div>
                  </div>
                  <div class="col" *ngIf="event.hasVivaWallet && (deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2)">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="enableVivaWalletCheckbox"
                             [(ngModel)]="deviceUser.enableVivaWallet">
                      <label class="form-check-label" for="enableVivaWalletCheckbox">VivaWallet</label>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col" *ngIf="event.hasWorldLine && (deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2)">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="enableWorldLineCheckbox"
                             [(ngModel)]="deviceUser.enableWorldLine">
                      <label class="form-check-label" for="enableWorldLineCheckbox">Worldline</label>
                    </div>
                  </div>
                  <div class="col" *ngIf="(deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2)">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="enableFiscalPrinter" [(ngModel)]="deviceUser.hasFiscalPrinter">
                      <label class="form-check-label" for="enableFiscalPrinter">Activate Fiscal Printer</label>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="enableDebugging" [(ngModel)]="deviceUser.enableDebugging">
                      <label class="form-check-label" for="enableDebugging">Enable Debugging</label>
                    </div>
                  </div>
                </div>
                <div class="row mt-3" *ngIf="deviceUser.hasFiscalPrinter">
                  <div class="col-sm-5">
                    <span style="font-weight: bold">Fiscal Printer Configuration</span>
                    <app-form-group-input class="mt-2" label="IP Address" [(model)]="deviceUser.fiscalPrinterIP"></app-form-group-input>
                  </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-right">
                        <button type="button" class="btn btn-danger btn-sm mr-2"
                            (click)="cancelDeviceUserUpdate()">Cancel</button>
                        <button type="button" class="btn btn-primary btn-sm"
                            (click)="updateDeviceUser()">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
